import request from '@/utils/request';


export function getShopPurchaseList(query) {
  return request({
    url: '/api/system/shopPurchase/queryShopPurchaseList',
    method: 'post',
    data: query
  });
}

export function getShopPurchase(query) {
  return request({
    url: '/api/system/shopPurchase/getShopPurchase',
    method: 'post',
    data: query
  });
}

export function saveShopPurchase(form) {
  return request({
    url: '/api/system/shopPurchase/saveShopPurchase',
    method: 'post',
    data: form
  });
}

export function batchSaveShopPurchase(form) {
  return request({
    url: '/api/system/shopPurchase/batchSaveShopPurchase',
    method: 'post',
    data: form
  });
}




// WEBPACK FOOTER //
// ./src/api/purchase/index.js